/** Tailwind-aligned breakpoints — mobile-first */
export const BREAKPOINTS = {
    xs: 375,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;

export const MEDIA_QUERIES = {
    xs: `(min-width: ${BREAKPOINTS.xs}px)`,
    sm: `(min-width: ${BREAKPOINTS.sm}px)`,
    md: `(min-width: ${BREAKPOINTS.md}px)`,
    lg: `(min-width: ${BREAKPOINTS.lg}px)`,
    xl: `(min-width: ${BREAKPOINTS.xl}px)`,
    "2xl": `(min-width: ${BREAKPOINTS["2xl"]}px)`,
    mobile: `(max-width: ${BREAKPOINTS.md - 1}px)`,
    tablet: `(min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.lg - 1}px)`,
    desktop: `(min-width: ${BREAKPOINTS.lg}px)`,
} as const;
